import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import CombinedSelect from '../combined';

const bem = new BEMHelper('CombinedSelectWithCustomValue');

class CombinedSelectWithCustomValue extends PureComponent {
    constructor(props) {
        super(props);

        const { options, value } = this.props;

        const isCustom = value && options ? !options.find((option) => option.value === value) && options.find((option) => option.value === '_custom') : false;

        this.state = {
            value: isCustom ? '_custom' : value,
            customValue: isCustom ? value : '',
            customFieldTouched: false,
        };
    }

    handleSelectChange = (value) => {
        const { onChange } = this.props;
        const { customFieldTouched, customValue } = this.state;

        this.setState({ value });

        if (value !== '_custom') {
            onChange(value);
        } else if (customFieldTouched) {
            onChange(customValue);
        }
    };

    handleCustomInputChange = (value) => {
        this.setState({ customValue: value, customFieldTouched: true });
        this.props.onChange(value);
    };

    handleFocus = (event) => {
        const { onFocus } = this.props;

        /* istanbul ignore else */
        if (event.relatedTarget !== this.inputRef && event.relatedTarget !== this.selectRef) {
            onFocus(event);
        }
    };

    handleBlur = (event) => {
        const { onBlur, onChange } = this.props;
        const { customValue, value } = this.state;

        /* istanbul ignore else */
        if (event.relatedTarget !== this.inputRef && event.relatedTarget !== this.selectRef) {
            onChange(value === '_custom' ? customValue : value);
            value === '_custom' ? onBlur() : onBlur(event);
        }
    };

    render() {
        const { className, customInputType, emptyLabel, label, options, ...rest } = this.props;

        const { customValue, value } = this.state;

        return (
            <div className={bem(null, null, className)}>
                <CombinedSelect
                    {...rest}
                    autoComplete="honorific-prefix"
                    emptyLabel={emptyLabel}
                    label={label}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    options={options}
                    selectRef={this.selectRef}
                    value={value}
                    onChange={(value) => {
                        this.handleSelectChange(value);
                    }}
                    ref={(node) => {
                        this.selectRef = node;
                    }}
                />

                {this.state.value === '_custom' ? (
                    <div className={bem('customInput')}>
                        <input
                            onBlur={this.handleBlur}
                            onChange={(event) => this.handleCustomInputChange(event.target.value)}
                            onFocus={this.handleFocus}
                            type={value === '_custom' ? (customInputType || 'text') : 'hidden'}
                            value={customValue}
                            ref={(node) => {
                                this.inputRef = node;
                            }}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

CombinedSelectWithCustomValue.propTypes = {
    emptyLabel: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    customInputType: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            key: PropTypes.string,
            label: PropTypes.string || PropTypes.node,
            labelNative: PropTypes.string,
        }),
    ),
};

CombinedSelectWithCustomValue.componentType = 'customSelect';

export default CombinedSelectWithCustomValue;
